<div class="overflow-x-auto">
  <div
    class="inline-grid min-w-full justify-end text-xs"
    [style.gridTemplateColumns]="gridColumns"
  >
    @for (col of columns(); track col.field) {
      <div
        class="py-2 text-center font-semibold wrap-break-word whitespace-normal"
      >
        {{ col.header }}
      </div>
    }

    @for (
      row of data();
      track row['id']?.value ?? row['index']?.value ?? $index
    ) {
      @let rowIndex = row['index']?.value ?? $index;
      @let tableFieldId = fieldId();
      @for (col of columns(); track col.field) {
        <div class="flex items-center justify-end p-0.5">
          @let cellValue = row[col.field]?.value;
          @let id = `${tableFieldId}-${col.field}-${rowIndex}`;
          @switch (col.type) {
            @case ('text') {
              <nsp-text-input
                [id]="id"
                [name]="id"
                [readonly]="col.readOnly ?? false"
                [disabled]="col.disabled ?? false"
                [ngModel]="cellValue"
                [style.backgroundColor]="
                  col.bgColorField ? row[col.bgColorField]?.value : null
                "
                class="w-full"
              />
            }

            @case ('number') {
              <nsp-number-input
                [id]="id"
                [name]="id"
                [maxFractionDigits]="3"
                [readonly]="col.readOnly ?? false"
                [disabled]="col.disabled ?? false"
                [required]="col.requiredFunction?.(row) ?? false"
                [ngModel]="cellValue"
                [style.backgroundColor]="
                  col.bgColorField ? row[col.bgColorField].value : null
                "
                class="w-full"
              />
            }

            @case ('select') {
              <nsp-select-input
                class="w-full leading-tight"
                [id]="id"
                [name]="id"
                [readonly]="col.readOnly ?? false"
                [disabled]="col.disabled ?? false"
                [options]="col.options"
                optionLabel="name"
                [value]="assertAsSelectOption(cellValue)"
                [ngModel]="cellValue"
                [style.backgroundColor]="
                  col.bgColorField ? row[col.bgColorField].value : null
                "
              />
            }

            @case ('autocomplete') {
              @if (col.options) {
                @let bg =
                  col.readOnly
                    ? 'bg-(--p-select-disabled-background)'
                    : 'bg-(--p-select-background)';
                @let text =
                  col.readOnly
                    ? '!text-(--p-inputtext-disabled-color)'
                    : 'text-(--p-select-color)';

                <p-autoComplete
                  [id]="id"
                  [name]="id"
                  [suggestions]="getFilteredOptions(col.field)"
                  [readonly]="col.readOnly ?? false"
                  [disabled]="col.disabled ?? false"
                  [dropdown]="true"
                  [fluid]="true"
                  field="name"
                  [ngModel]="cellValue"
                  (completeMethod)="filter($event, col.options, col.field)"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="3"
                  optionLabel="name"
                  [inputStyleClass]="`w-full ${bg} ${text}`"
                  [inputStyle]="{
                    'background-color': col.bgColorField
                      ? row[col.bgColorField]?.value
                      : null,
                  }"
                  class="w-full"
                />
              } @else {
                <div>No options</div>
              }
            }

            @case ('checkbox') {
              <nsp-checkbox-input
                [ngClass]="{ invisible: col?.hideFunction?.(row) }"
                [id]="id"
                [name]="id"
                [readonly]="col.readOnly ?? false"
                [value]="cellValue ? true : false"
                [ngModel]="cellValue ? true : false"
                [style.backgroundColor]="
                  col.bgColorField ? row[col.bgColorField].value : null
                "
                class="w-full justify-items-center justify-self-center"
              />
            }

            @case ('datepicker') {
              <nsp-calendar-input
                [id]="id"
                [name]="id"
                [value]="assertAsDate(cellValue)"
                [ngModel]="assertAsDate(cellValue)"
                [readonly]="col.readOnly ?? false"
                [disabled]="col.disabled ?? false"
                hourFormat="24"
                class="w-full"
              />
            }

            @case ('rowTitle') {
              <div class="flex items-center justify-end pr-2 pb-1 text-right">
                @if (required()) {
                  <span class="pr-2 text-red-500">*</span>
                }
                {{ cellValue }}
                @if (col.subtitleField) {
                  <span class="text-gray-500"
                    >({{ row[col.subtitleField]?.value }} m<sup>3</sup>)</span
                  >
                }
              </div>
            }
          }
        </div>
      }
    }
  </div>
</div>
